var symphony = symphony || {};

;
symphony.agenda = {

    initCount: 0,
    init: function () {
        if (typeof commConnApiUrl == "undefined" || commConnApiUrl == null || commConnApiUrl == '') {
            return;
        }

        if (this.initCount == 0 && typeof krocCenterWebId == "undefined" && document.body.classList.contains('admin-body')) {
            window.krocCenterWebId = symphony.siteSettings.data.krocCenterWebId;
        }
        if (symphony.agenda.initCount < 5) {

            // Find all iFrames
            var i, frames;
            frames = document.getElementsByTagName("iframe");
            for (i = 0; i < frames.length; ++i) {
                if (frames[i].src.toLowerCase().indexOf("calendarcontrol")) {

                    // don't render the agenda inside free text area
                    if ($(frames[i]).parents(".alloy-contentContainer").length == 0) {
                        var params = symphony.agenda.getUrlVars(frames[i].src);
                        if (typeof params.centerId != "undefined") {
                            $(frames[i]).attr('class', 'desktop-calendar');
                            $(frames[i]).before("<div class='mobile-calendar' id='agenda-" + i + "'></div>");
                            this.loadAgenda(params, i);
                        }
                    }
                }
            }
        }
    },


    renderAgenda: function (index, date) {
        date = moment(date);
        var container = $('#agenda-' + index);
        var allActivities = JSON.parse(JSON.stringify($('#agenda-' + index).data('agendaItems')));
        $(container).html(
            "<div class='agenda-header u-semibold'>" +
            "<div class='lft-arrow fa fa-chevron-left' onclick='symphony.agenda.onPreviousDay(this," + index + ")'></div>" +
            "<div class='agenda-header-title'>" +
            moment(date).format("dddd, MMMM Do, YYYY") +
            "</div>" +
            "<div class='rt-arrow fa fa-chevron-right' onclick='symphony.agenda.onNextDay(this," + index + ")'></div>" +
            "</div>"
        );

        // Check if selected date is today
        if (this.checkDateEquality(date, moment())) {
            $(container).find('.lft-arrow').addClass('arrow-hidden');
        } else {
            $(container).find('.lft-arrow').removeClass('arrow-hidden');
        }

        // Checks if selected date is a week from today
        if (this.checkDateEquality(date, moment().add('7', 'days'))) {
            $(container).find('.rt-arrow').addClass('arrow-hidden');
        } else {
            $(container).find('.rt-arrow').removeClass('arrow-hidden');
        }

        if (allActivities) {

            var todaysActivities = $.grep(allActivities, function (a) {
                return moment(a.activityDate).startOf('day').isSame(moment(date).startOf('day'));
            });

            if (todaysActivities.length < 1) {
                $(container).append(
                    "<div class='no-activities'> No Activities Today </div>"
                );
            } else {
                var $activities = $('<div class="agenda-activities"></div>');
                for (var i = 0; i < todaysActivities.length; i++) {
                    var activity = todaysActivities[i];
                    $activities.append(symphony.templates["agenda-view"]({
                        classType: activity.classType.description,
                        instructors: activity.instructors,
                        venues: activity.venueDescription,
                        activityTitle: activity.description,
                        startTime: activity.startTime < 720 && activity.endTime > 720 ? activity.activityStartTime + "am" : activity.activityStartTime,
                        endTime: activity.endTime < 720 ? activity.activityEndTime + "am" : activity.activityEndTime + "pm",
                        classTypeStyle: activity.classType.description.toLowerCase(),
                        salesUrl: activity.salesUrl ? activity.salesUrl : ''
                    }));
                }
                $(container).append($activities);
            }
        }

    },

    loadAgenda: function (params, index) {
        var todaysDate = moment().format("YYYY-MM-DD");
        var nextWeek = moment().add(7, 'd').format("YYYY-MM-DD");

        var starttime = (params.minHours ? Number(params.minHours) : 5) * 60;
        var endtime = (params.maxHours ? Number(params.maxHours) : 22) * 60;

        var kindid = '';
        if (params.venueShortId) {
            var venueArr = params.venueShortId.split(',');
            for (var i = 0; i < venueArr.length; i++) {
                venueArr[i] = venueArr[i].split(':')[0];
            }
            params.venueShortId = venueArr.join(',');
            kindid = 'venueshortid:' + params.venueShortId;
        } else if (params.categoryShortId) {
            var categoryArr = params.categoryShortId.split(',');
            for (var i = 0; i < categoryArr.length; i++) {
                categoryArr[i] = categoryArr[i].split(':')[0];
            }
            params.categoryShortId = categoryArr.join(',');
            kindid = 'categoryshortid:' + params.categoryShortId;
        } else if (params.personnelBarcode) {
            kindid = 'personnelid:' + params.personnelBarcode;
        }

        var classtype = '';
        if (params.roster == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'roster';
        }
        if (params.dropIn == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'dropin';
        }
        if (params.rentalPublic == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'publicrental';
        }
        if (params.rentalPrivate == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'privaterental';
        }
        if (params.reservationPublic == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'publicreservation';
        }
        if (params.reservationPrivate == '1') {
            classtype += (classtype.length > 0 ? ',' : '') + 'privatereservation';
        }

        var body = {
            searchText: 'startdate:' + todaysDate + ' enddate:' + nextWeek + ' ' + kindid + ' classtype:' + classtype + ' starttime:' + starttime + ' endtime:' + endtime,
            openUseOnly: params.reservationUsage.indexOf('23644082-9e76-4d88-9522-3858e1dcc4cf') > -1 ? 'true' : 'false',
            useEventTimes: params.rentalUseEventTimes === '1' || params.rentalUseEventTimes === true ? 'true' : 'false'
        };

        $.ajax({
            url: commConnApiUrl + '/api/dashboard/upcoming-activities/' + params.centerId + '?searchText=' + body.searchText + '&openUseOnly=' + body.openUseOnly + '&useEventTimes=' + body.useEventTimes,
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'GET',
            dataType: 'json',
            success: function (response) {

                if (response.data.items) {
                    var activities = response.data.items;

                    activities.sort(function (a, b) {
                        return a.startTime - b.startTime
                    });
                    for (var i = 0; i < activities.length; i++) {
                        var activity = activities[i];

                        if (krocCenterWebId.length < 1 || krocSalesUrl.length < 1) {
                            activity.salesUrl = '';
                        } else {
                            if (activity.classType.description.toLowerCase() == "drop-in") {
                                activity.salesUrl = krocSalesUrl + "/#/" + krocCenterWebId + "/dropin/" + activity.id + "/";
                            } else if (activity.classType.description.toLowerCase() == 'roster') {
                                activity.salesUrl = krocSalesUrl + "/#/" + krocCenterWebId + "/program/" + activity.classInstanceId + "/";
                            }
                        }
                        activity.activityStartTime = symphony.agenda.convertMinsToHrsMins(activity.startTime);
                        activity.activityEndTime = symphony.agenda.convertMinsToHrsMins(activity.endTime);
                    }

                    document.getElementById('agenda-' + index).dataset.agendaItems = JSON.stringify(activities);
                }
                symphony.agenda.renderAgenda(index, todaysDate);
            }
        });
    },

    onNextDay: function (arrow, index) {
        var container = arrow.parentElement.parentElement;
        var date = new Date();
        var nextDay = new Date(date);

        if (container.dataset.date) {
            date = new Date(container.dataset.date);
        }

        nextDay = moment(date).add(1, 'days');
        container.dataset.date = nextDay;
        $('#agenda-' + index).scrollTop(0);

        this.renderAgenda(index, moment(nextDay), null);
    },

    onPreviousDay: function (arrow, index) {
        var container = arrow.parentElement.parentElement;
        var date = new Date();
        var prevDay = new Date(date);

        if (container.dataset.date) {
            date = new Date(container.dataset.date);
        }

        prevDay = moment(date).subtract(1, 'days');
        container.dataset.date = prevDay;
        $('#agenda-' + index).scrollTop(0);

        this.renderAgenda(index, prevDay, null);
    },

    checkDateEquality: function (date1, date2) {
        date1 = moment(date1).format("dddd, MMMM Do, YYYY");
        date2 = moment(date2).format("dddd, MMMM Do, YYYY");
        if (date1 == date2) {
            return true;
        } else {
            return false;
        }
    },

    convertMinsToHrsMins: function (mins) {
        var h = Math.floor(mins / 60);
        var m = mins % 60;
        h = h < 10 ? h : h;
        m = m < 10 ? '0' + m : m;
        var militaryTime = h + ":" + m;

        return symphony.agenda.toStandardTime(militaryTime);
    },

    toStandardTime: function (militaryTime) {
        militaryTime = militaryTime.split(':');

        if (militaryTime[0].charAt(0) == 1 && militaryTime[0].charAt(1) > 2) {
            return (militaryTime[0] - 12) + ':' + militaryTime[1];
        } else if (militaryTime[0].charAt(0) == 2 && militaryTime[0].charAt(1) >= 0 && militaryTime[0].charAt(1)) {
            return (militaryTime[0] - 12) + ':' + militaryTime[1];
        } else {
            return militaryTime.join(':');
        }

    },

    getUrlVars: function (url) {
        var vars = [],
            hash;
        var hashes = url.slice(url.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    },

    restartInit: function ($container) {
        setTimeout(function () {
            symphony.agenda.initCount++;
            symphony.agenda.init($container);
        }, 1000);
    }
};
